






import { Component, Vue } from "vue-property-decorator";
// 声明组件*****************
@Component({
  components: {
  }
})
export default class FireTraining extends Vue {
  // 属性*****************
}
